<div class="row my-3">
    <div class="col text-end">
        <app-module-question-bank-add [isEditMode]="isEditMode"
                              [moduleId]="moduleId"
                              (moduleQuestionBankAdded)="onModuleQuestionBankAdded($event)">
        </app-module-question-bank-add>
    </div>
</div>

<section class="panel">
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Question Bank Name</th>
                        <th>Audit Type</th>
                        <th class="text-center">Order</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    <tr *ngFor="let moduleQuestionBank of moduleQuestionBanks;index as i" cdkDrag class="draggable">
                        <td>{{i+1}}</td>
                        <td>{{moduleQuestionBank.questionBankName}}</td>
                        <td>{{moduleQuestionBank.auditType}}</td>
                        <td class="text-center">{{moduleQuestionBank.zOrder}}</td>
                        <td class="actions text-center">
                            <a *ngIf="isEditMode" (click)="selectedModuleQuestionBankId=moduleQuestionBank.id; confirmation.showMessage()" title="Delete Question Bank" class="mb-1 mt-1 me-2 text-primary"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteModuleQuestionBank()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this question bank?'">
</app-confirmation-message>
